export { default } from './LayoutFooterInner';
